import React, { useCallback, useState } from 'react';
import Modal from '../../components/Modal';
import Toggle from '../../components/Toggle';
import { editObjectApi } from '../../api/api';
import { toast } from 'react-toastify';

const VacationMode = ({ showModal, setShowModal, selectedObject }) => {
  const [vacation, setVacation] = useState(selectedObject?.vacation ?? false);

  const onChange = useCallback(
    async (value) => {
      setVacation(value);
      const newObj = { ...selectedObject, vacation: value };

      await editObjectApi(
        newObj,
        function () {},
        function (err) {
          toast.error(err.error, { hideProgressBar: true });
        }
      );
    },
    [selectedObject]
  );

  return (
    <Modal showModal={showModal} setShowModal={setShowModal} title={'Режим отпуска'}>
      <Toggle label={'Включить режим отпуска:'} value={vacation} onChange={onChange} />
      <p className={'text-gray-700 gap-1 text-xs ml-2 mt-2'}>
        Когда включен "Режим отпуска", счетчик <strong>не учитывает обычное потребление</strong>, а любые поступающие импульсы фиксируются как{' '}
        <strong>тревога</strong>, чтобы вы знали о возможной активности во время вашего отсутствия.
      </p>
    </Modal>
  );
};
export default VacationMode;
